import { render, staticRenderFns } from "./academy_clinics.vue?vue&type=template&id=88e8ba98&scoped=true"
import script from "./academy_clinics.vue?vue&type=script&lang=js"
export * from "./academy_clinics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e8ba98",
  null
  
)

export default component.exports